import { useEffect, useState } from "react"
import { getTeamMemberBucketDaysResumeById } from "../../../../../services/vacation.service"

/**
 * Hook para obtener la información de la cubeta de vacaciones de un integrante del equipo.
 * @param {Object} param0 - Parámetros del hook.
 * @param {string} param0.teamMemberId - ID del integrante del equipo.
 */
export default function useFetchTeamMemberVacationsBucket({
  teamMemberId,
  workAnniversary,
  periodStartDate,
  periodEndDate,
}) {
  const [bucket, setBucket] = useState(
    /** @type {TeamMemberBucketInfo | null} */ (null)
  )
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    let isMounted = true

    if (isMounted && teamMemberId) {
      fetchTeamMemberBucket(teamMemberId)
    }

    return () => {
      isMounted = false
    }
  }, [teamMemberId])

  async function fetchTeamMemberBucket(teamMemberId) {
    if (isLoading) return
    try {
      setIsLoading(true)
      const { success, result } = await getTeamMemberBucketDaysResumeById(
        teamMemberId,
        workAnniversary,
        periodStartDate,
        periodEndDate
      )

      if (!success) return

      setBucket({
        data: result.data,
        rangeToConsider: result.rangeToConsider,
        actualAvailableDays: result.actualAvailableDays,
        actualBucketDays: result.actualBucketDays,
      })
    } catch (error) {
      console.error("Error fetching team member bucket:", error)
    } finally {
      setIsLoading(false)
    }
  }

  return { bucket, isLoading }
}

/**
 * @typedef {Object} TeamMemberBucketInfo
 * @property {Array<{
 *   name: string,
 *   monthsData: Array<{
 *     month: number,
 *     year: number,
 *     daysCounter: number
 *   }>
 * }>} bucketMonthsInfo - Información de los meses por cubeta.
 * @property {number[]} rangeToConsider - Meses a considerar en el rango.
 * @property {number[]} actualAvailableDays - Días disponibles por mes.
 * @property {number} actualBucketDays - Días actuales en la cubeta.
 */
